import {isDevEnv} from './env';

export const translateAdditionalMarkup = i18n => markup => markup.replace(/\{\{([^}]+)\}\}/g, (_, key) => i18n(key));

const mergeValueAndArgs = (value, args) => value.replace(/([^']|^)\{(\d+)\}/g, (_, pre, i) => {
    const index = Number(i);
    if (index >= args.length) {
        return pre;
    }
    return pre + args[Number(i)];
});

export const translate = (map, key, ...args) => {
    if (!map) {
        if (isDevEnv) {
            console.warn('[I18n]: translation service is not yet up and running'); // eslint-disable-line
        }
        return key;
    }
    if (!map[key]) {
        if (isDevEnv) {
            console.warn('[I18n]: Key %s is not known', key);  // eslint-disable-line
        }
        return key;
    }
    if (args.length === 0) {
        return map[key];
    }

    return mergeValueAndArgs(map[key], args);
};



// WEBPACK FOOTER //
// ./src/translate.js